var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPoliciesAndControls = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F0F1F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 36L23.5449 36.8904C23.8307 37.0365 24.1693 37.0365 24.4551 36.8904L24 36ZM24 36C24.4551 36.8904 24.4554 36.8903 24.4557 36.8901L24.4566 36.8897L24.4589 36.8885L24.4659 36.8849L24.4896 36.8725C24.5096 36.8621 24.5379 36.8471 24.5739 36.8278C24.6461 36.7891 24.7493 36.7327 24.8792 36.6592C25.1389 36.5122 25.5059 36.2964 25.9446 36.0161C26.82 35.4569 27.9911 34.6343 29.1667 33.5828C31.4791 31.5145 34 28.3874 34 24.5V15.3C34 14.8431 33.6903 14.4443 33.2476 14.3311L24.2476 12.0311C24.0851 11.9896 23.9149 11.9896 23.7524 12.0311L14.7524 14.3311C14.3097 14.4443 14 14.8431 14 15.3V24.5C14 28.3874 16.5209 31.5145 18.8333 33.5828C20.0089 34.6343 21.18 35.4569 22.0554 36.0161C22.4941 36.2964 22.8611 36.5122 23.1208 36.6592C23.2507 36.7327 23.3539 36.7891 23.4261 36.8278C23.4621 36.8471 23.4904 36.8621 23.5104 36.8725L23.5341 36.8849L23.5411 36.8885L23.5434 36.8897L23.5443 36.8901C23.5446 36.8903 23.5449 36.8904 24 36Z",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 31C24 31 29 28.2 29 24V18.4L24 17L19 18.4V24C19 28.2 24 31 24 31Z",
    stroke: "#071A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPoliciesAndControls);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/policiesAndControls.a9ac83a8e1b19a7f577921f587bd734b.svg";